import { render, staticRenderFns } from "./change_brand.vue?vue&type=template&id=41f95a59&scoped=true&"
import script from "./change_brand.vue?vue&type=script&lang=js&"
export * from "./change_brand.vue?vue&type=script&lang=js&"
import style0 from "./change_brand.vue?vue&type=style&index=0&id=41f95a59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f95a59",
  null
  
)

export default component.exports